interface IAppConst {
  headerHeight: number;
  baseApiURL: string;
  OIDC_AUTHORITY: string;
  OIDC_LOGOUT: string;
  OIDC_CLIENT_ID: string;
  OIDC_REDIRECT_URI: string;
  OIDC_CLIENT_SECRET: string;
  OIDC_SCOPE: string;
  OIDC_UNIT: string;
  LOGO: string;
  NAME_UNIT: string;
  GOV_NAME: string;
  MAU_BIEN_LAI_SINH_VIEN: string;
  MAU_BIEN_LAI_SINH_VIEN_NHAP_HOC: string;
  /** "1" = màn Thu phí nhập học có THÊM bước 4 "Biên nhận nhập học" (3 bước cũ giữ nguyên). Mặc định "0". */
  TAB_BIEN_NHAN_NHAP_HOC: string;
  MAU_BIEN_LAI_THI_SINH_TUYEN_SINH: string;
  MENU_PHAN_QUYEN: string;
  THEME: string;
  THEME_COLOR_PRIMARY: string;
  THEME_COLOR_PRIMARY_HOVER: string;
  THEME_COLOR_PRODUCT: string;
  THEME_COLOR_TEXT_PARENT: string;
  THEME_COLOR_HOVER: string;
  THEME_COLOR_HEADER: string;
  /** KIỂU bày thanh trên cùng + menu: ""/"mac_dinh" = bản gốc, "thanh_lich" = bản gọn.
   *  Chỉ đổi cách bày, KHÔNG đổi bộ màu — màu vẫn theo các THEME_COLOR_* ở trên. */
  THEME_LAYOUT: string;
  /** Dòng chữ NHỎ ở khối trái thanh trên cùng (mặc định "Phần mềm quản lý"). */
  HEADER_DONG_TREN: string;
  /** Dòng chữ ĐẬM ở khối trái (mặc định "Đại học số"). */
  HEADER_TEN_HE_THONG: string;
  /** Phần chữ được TÔ MÀU RIÊNG nối ngay sau dòng đậm (mặc định "ESSOFT"). Để trống thì bỏ hẳn. */
  HEADER_NHAN_MANH: string;
  /** Dòng chữ dưới tên đơn vị (mặc định "Phần mềm quản lý tài chính"). */
  HEADER_TEN_PHAN_MEM: string;
  /** "1" = ô chữ trên thanh trên cùng nào bị XÓA TRẮNG thì ẨN HẲN dòng đó, KHÔNG lùi về chữ
   *  mặc định của bản web. Mặc định "0" = giữ nết cũ (trống ⇒ dùng chữ mặc định). */
  HEADER_CHO_PHEP_TRONG: string;
  /** ẢNH NỀN THANH TRÊN CÙNG. Tên file đã tải lên ở màn Cấu hình, hoặc địa chỉ ảnh đầy đủ.
   *  Rỗng = không dùng ảnh nền, thanh trên cùng giữ nguyên như trước. */
  THEME_BG_HEADER: string;
  /** background-position của ảnh nền thanh trên cùng. Rỗng = "center center". */
  THEME_BG_HEADER_POSITION: string;
  /** background-size: cover / contain / auto / 100% 100%… Rỗng = "cover". */
  THEME_BG_HEADER_SIZE: string;
  /** background-repeat: no-repeat / repeat / repeat-x / repeat-y. Rỗng = "no-repeat". */
  THEME_BG_HEADER_REPEAT: string;
  /** Độ phủ màu chủ đạo lên ảnh thanh trên cùng, 0–100. Rỗng/"0" = ảnh rõ nguyên bản. */
  THEME_BG_HEADER_OPACITY: string;
  /** ẢNH NỀN MENU BÊN TRÁI — cùng cách khai như bộ THEME_BG_HEADER_*. */
  THEME_BG_MENU: string;
  THEME_BG_MENU_POSITION: string;
  THEME_BG_MENU_SIZE: string;
  THEME_BG_MENU_REPEAT: string;
  THEME_BG_MENU_OPACITY: string;
  /** Số hiệu bản phát hành, in ở chân menu kiểu "Thanh lịch". */
  APP_VERSION: string;
  URL_KY_TUC_XA: string;
  TRA_SOAT_FROM_API: string;
  URL_CHANGE_PASSWORD: string;
  IS_DEMO: string;
  BANK_DEFAULT: string;
  FILEPATH_BASE_URL: string;
  ENABLE_FAST: string;
  ENABLE_FAKE: string;
  DEFAULT_PRINT_BIENLAI: string;
  CHO_PHEP_SUA_NGAY_THU: string;
  IS_SHOW_NOFITICATION: string;
  /** "0" = tắt thẻ thông báo góc dưới phải. Rỗng/khác "0" = bật (hành vi cũ). */
  HIEN_THONG_BAO_GOC_MAN: string;
}
export const appConst: IAppConst = {
  headerHeight: 56,
  baseApiURL: process.env.REACT_APP_API_BASE_URL?.toString() ?? "",
  OIDC_AUTHORITY: process.env.REACT_APP_OIDC_AUTHORITY?.toString() ?? "",
  OIDC_LOGOUT: process.env.REACT_APP_OIDC_LOGOUT?.toString() ?? "",
  OIDC_CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID?.toString() ?? "",
  OIDC_CLIENT_SECRET:
    process.env.REACT_APP_OIDC_CLIENT_SECRET?.toString() ?? "",
  OIDC_REDIRECT_URI: process.env.REACT_APP_OIDC_REDIRECT_URI?.toString() ?? "",
  OIDC_UNIT: process.env.REACT_APP_OIDC_UNIT?.toString() ?? "",
  OIDC_SCOPE: process.env.REACT_APP_OIDC_SCOPE?.toString() ?? "",
  URL_CHANGE_PASSWORD:
    process.env.REACT_APP_URL_CHANGE_PASSWORD?.toString() ?? "",

  MENU_PHAN_QUYEN: process.env.REACT_APP_MENU_PHAN_QUYEN?.toString() ?? "0",
  LOGO: process.env.REACT_APP_LOGO?.toString() ?? "",
  NAME_UNIT: process.env.REACT_APP_NAME_UNIT?.toString() ?? "",
  GOV_NAME: process.env.REACT_APP_GOV_NAME?.toString() ?? "",
  MAU_BIEN_LAI_SINH_VIEN:
    process.env.REACT_APP_BIEN_LAI_SINH_VIEN?.toString() ?? "03",
  MAU_BIEN_LAI_SINH_VIEN_NHAP_HOC:
    process.env.REACT_APP_BIEN_SINH_VIEN_NHAP_HOC?.toString() ?? "04",
  // Mặc định "0" = chỉ 3 bước như cũ (không đơn vị nào đổi hành vi nếu chưa bật).
  TAB_BIEN_NHAN_NHAP_HOC:
    process.env.REACT_APP_TAB_BIEN_NHAN_NHAP_HOC?.toString() ?? "0",
  MAU_BIEN_LAI_THI_SINH_TUYEN_SINH:
    process.env.REACT_APP_BIEN_SINH_VIEN_TUYEN_SINH?.toString() ?? "05",

  //style
  THEME: process.env.REACT_APP_THEME?.toString() ?? "",
  THEME_COLOR_PRIMARY:
    process.env.REACT_APP_THEME_COLOR_PRIMARY?.toString() ?? "",
  THEME_COLOR_PRIMARY_HOVER:
    process.env.REACT_APP_THEME_COLOR_PRIMARY_HOVER?.toString() ?? "",
  THEME_COLOR_PRODUCT:
    process.env.REACT_APP_THEME_COLOR_PRODUCT?.toString() ?? "",
  THEME_COLOR_TEXT_PARENT:
    process.env.REACT_APP_THEME_COLOR_TEXT_PARENT?.toString() ?? "",
  THEME_COLOR_HOVER: process.env.REACT_APP_THEME_COLOR_HOVER?.toString() ?? "",
  THEME_COLOR_HEADER:
    process.env.REACT_APP_THEME_COLOR_HEADER?.toString() ?? "",
  // Rỗng = kiểu mặc định. Đơn vị chưa khai gì thì giao diện y như trước.
  THEME_LAYOUT: process.env.REACT_APP_THEME_LAYOUT?.toString() ?? "",
  // Chữ trên thanh trên cùng: mặc định ĐÚNG như đang chạy, để đơn vị chưa khai gì thì không đổi
  // một chữ nào. Khai ở màn Cấu hình sẽ ghi đè.
  HEADER_DONG_TREN:
    process.env.REACT_APP_HEADER_DONG_TREN?.toString() ?? "Phần mềm quản lý",
  HEADER_TEN_HE_THONG:
    process.env.REACT_APP_HEADER_TEN_HE_THONG?.toString() ?? "Đại học số",
  HEADER_NHAN_MANH:
    process.env.REACT_APP_HEADER_NHAN_MANH?.toString() ?? "ESSOFT",
  HEADER_TEN_PHAN_MEM:
    process.env.REACT_APP_HEADER_TEN_PHAN_MEM?.toString() ??
    "Phần mềm quản lý tài chính",
  HEADER_CHO_PHEP_TRONG: "0",
  // Ảnh nền: mặc định RỖNG ở mọi đơn vị — chưa khai thì giao diện y như trước.
  THEME_BG_HEADER: process.env.REACT_APP_THEME_BG_HEADER?.toString() ?? "",
  THEME_BG_HEADER_POSITION:
    process.env.REACT_APP_THEME_BG_HEADER_POSITION?.toString() ?? "",
  THEME_BG_HEADER_SIZE:
    process.env.REACT_APP_THEME_BG_HEADER_SIZE?.toString() ?? "",
  THEME_BG_HEADER_REPEAT:
    process.env.REACT_APP_THEME_BG_HEADER_REPEAT?.toString() ?? "",
  THEME_BG_HEADER_OPACITY:
    process.env.REACT_APP_THEME_BG_HEADER_OPACITY?.toString() ?? "",
  THEME_BG_MENU: process.env.REACT_APP_THEME_BG_MENU?.toString() ?? "",
  THEME_BG_MENU_POSITION:
    process.env.REACT_APP_THEME_BG_MENU_POSITION?.toString() ?? "",
  THEME_BG_MENU_SIZE: process.env.REACT_APP_THEME_BG_MENU_SIZE?.toString() ?? "",
  THEME_BG_MENU_REPEAT:
    process.env.REACT_APP_THEME_BG_MENU_REPEAT?.toString() ?? "",
  THEME_BG_MENU_OPACITY:
    process.env.REACT_APP_THEME_BG_MENU_OPACITY?.toString() ?? "",
  APP_VERSION: process.env.REACT_APP_VERSION?.toString() ?? "1.0.0",

  URL_KY_TUC_XA: process.env.REACT_APP_URL_KY_TUC_XA?.toString() ?? "",
  TRA_SOAT_FROM_API: process.env.REACT_APP_TRA_SOAT_FROM_API?.toString() ?? "1",

  IS_DEMO: process.env.REACT_APP_IS_DEMO?.toString() ?? "0",
  BANK_DEFAULT: process.env.REACT_APP_BANK_DEFAULT?.toString() ?? "",
  FILEPATH_BASE_URL:
    process.env.REACT_APP_FILEPATH_BASE_URL?.toString() ?? "~/",
  ENABLE_FAST: process.env.REACT_APP_ENABLE_FAST?.toString() ?? "0",
  ENABLE_FAKE: process.env.REACT_APP_ENABLE_FAKE?.toString() ?? "0",
  DEFAULT_PRINT_BIENLAI:
    process.env.REACT_APP_DEFAULT_PRINT_BIENLAI?.toString() ?? "-1",
  CHO_PHEP_SUA_NGAY_THU:
    process.env.REACT_APP_CHO_PHEP_SUA_NGAY_THU?.toString() ?? "1",
  IS_SHOW_NOFITICATION:
    process.env.REACT_APP_IS_SHOW_NOFITICATION?.toString() ?? "0",
  HIEN_THONG_BAO_GOC_MAN:
    process.env.REACT_APP_HIEN_THONG_BAO_GOC_MAN?.toString() ?? "1",
};
